export function Field({ label, error, hint, children, testId }) {
  return (
    <div data-testid={testId}>
      <label className="field-label">{label}</label>
      {children}
      {hint && !error && <p className="mt-1.5 text-sm text-zinc-500">{hint}</p>}
      {error && (
        <p className="mt-1.5 text-sm font-semibold text-[#DC2626]" data-testid={`${testId}-error`}>
          {error}
        </p>
      )}
    </div>
  );
}

export function StepContact({ form, update, errors }) {
  return (
    <div className="space-y-6">
      <h2 className="font-display text-2xl font-bold">Step 1 · Your contact details</h2>
      <Field label="Full name" error={errors.name} testId="field-name">
        <input
          className="field-input"
          placeholder="e.g. Aditi Sharma"
          value={form.name}
          onChange={(e) => update({ name: e.target.value })}
          data-testid="contact-name-input"
          autoComplete="name"
        />
      </Field>
      <Field label="Phone (WhatsApp)" error={errors.phone} testId="field-phone">
        <input
          className="field-input"
          placeholder="e.g. 98765 43210"
          value={form.phone}
          onChange={(e) => update({ phone: e.target.value })}
          data-testid="contact-phone-input"
          inputMode="tel"
          autoComplete="tel"
        />
      </Field>
      <Field label="Email" error={errors.email} testId="field-email">
        <input
          className="field-input"
          placeholder="you@example.com"
          value={form.email}
          onChange={(e) => update({ email: e.target.value })}
          data-testid="contact-email-input"
          inputMode="email"
          autoComplete="email"
        />
      </Field>
    </div>
  );
}
